import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import _ from 'lodash';
import HeadTags from './head';
import LandingPage from './landingPage';

class Home extends React.Component {
  render() {
    const showLandingPage = _.isEmpty(this.props.address);

    return (
      <Fragment>
        <HeadTags />
        {showLandingPage ? <LandingPage /> : <Redirect to="/welcome" />}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    address: state.address
  };
}

export default connect(mapStateToProps, {})(Home);
